import * as React from 'react'
import { GlobalContext } from '../../globalContext'

export default function useNotification() {
  const { notifications, updateContext } = React.useContext(GlobalContext)

  const showNotification = (id: string, text: string) => {
    updateContext(draft => {
      draft.notifications = [{ id, text }, ...notifications.filter(n => n.id != id)]
    })
  }

  return { showNotification }
}
